import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExposicionSelectionService {
  private readonly storageKey = 'bgw-pwa-selected-exposicion-id';

  public setSelectedExposicionId(exposicionId: number | null): void {
    try {
      if (!exposicionId || !Number.isFinite(exposicionId) || exposicionId <= 0) {
        localStorage.removeItem(this.storageKey);
        return;
      }

      localStorage.setItem(this.storageKey, String(exposicionId));
    } catch (error) {
      console.log(error);
    }
  }

  public getSelectedExposicionId(): number | null {
    try {
      const rawValue = localStorage.getItem(this.storageKey);
      if (!rawValue) {
        return null;
      }

      const exposicionId = Number(rawValue);
      if (!Number.isFinite(exposicionId) || exposicionId <= 0) {
        return null;
      }

      return exposicionId;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}
